var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// This is a generated file from running the "createIcons" script. This file should not be updated manually.
import React, { forwardRef } from "react";
import { FontIcon } from "@react-md/icon";
export var PanoramaFishEyeFontIcon = forwardRef(function PanoramaFishEyeFontIcon(props, ref) {
    return (React.createElement(FontIcon, __assign({}, props, { ref: ref }), "panorama_fish_eye"));
});
//# sourceMappingURL=PanoramaFishEyeFontIcon.js.map